<template>
  <section class="page-product-specifications row-1">
    <!-- Title -->
    <div>
      <h2 class="text-xl">
        {{ $t('pages.product.specTitle') }}
      </h2>
    </div>

    <!-- Content -->
    <div class="page-product-specifications__wrap m-top-5">
      <div class="page-product-specifications__info">
        <div class="page-product-specifications__info__blocks">
          <PagesProductSpecificationsBlocks :product="props.product" />
        </div>
        <div
          class="page-product-specifications__info__image"
          v-if="specificationImage?.[0]"
        >
          <div
            class="page-product-specifications__info__image__wrap"
            :class="{
              '--vertical':
                specificationImage[0].height >= specificationImage[0].width,
            }"
          >
            <WidgetPicture
              :image="{
                custom: specificationImage[0],
              }"
              :lazyLoad="true"
              :alt="specificationImage[0].title"
            />
          </div>
        </div>
      </div>

      <div class="page-product-specifications__accordions">
        <!-- Accordion -->
        <PagesProductSpecificationsAccordions
          :product="props.product"
          :meta="{ dimerable: props.product?.productDimerable }"
        />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PagesProductSpecifications',
}
</script>

<script setup>
const props = defineProps({
  product: Object,
})

const { locale } = useI18n()

const specificationImage = computed(() => {
  return locale.value === 'en-us'
    ? props.product.productSpecificationImageUsa
    : props.product.productSpecificationImage
})
</script>

<style lang="scss">
@import './style.scss';
</style>
